module.exports = __webpack_public_path__ + "static/media/henry-newyears.5a7b041a.jpg";